'use client';

import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import clsx from 'clsx';
import { useSearchParams } from 'next/navigation';

import { publicEnv } from '@/lib/env';
import { BlogNavigationTabs } from '@/modules/blog/BlogNavigationTabs';
import { Category } from '@/types/blog.types';

interface MemeHeaderWithNavProps {
  category: Category;
  categorySlug: string;
}

export const MemeHeaderWithNav = ({ category, categorySlug }: MemeHeaderWithNavProps) => {
  const possibleSubcategories = category?.subcategories?.filter(
    (subcategory) => +subcategory.articleCount > 0
  );
  const searchParams = useSearchParams();
  const subCategory = searchParams?.get('subcategory') || '';

  return (
    <div className='flex w-full flex-col px-0.5 sm:mx-auto'>
      {possibleSubcategories.length > 0 && (
        <BlogNavigationTabs
          subcategories={possibleSubcategories || []}
          categorySlug={categorySlug}
          allUrl={`/${categorySlug}/1`}
        />
      )}

      <div
        className={clsx(
          'mt-8 h-14 rounded-lg bg-gradient-to-r from-[#572BD6] to-[#0A0026] sm:h-32 lg:rounded-none',
          possibleSubcategories.length === 0 && 'mt-2'
        )}
      >
        <div
          className='size-full bg-[length:1280px_235px]'
          style={{
            backgroundImage: `url(${getCDNURL(`${publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL}/global/legacy/match-stats-bg.svg`, 1280, 235)})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
        >
          <div className='flex size-full flex-col justify-center pl-6 text-white sm:pl-8'>
            <div className='text-xl font-bold sm:text-4xl'>
              {`${subCategory ? `Pickleball ${subCategory.charAt(0).toUpperCase()}${subCategory.slice(1)}` : ''}`}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
